import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3e56fcb6&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=3e56fcb6&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e56fcb6')) {
      api.createRecord('3e56fcb6', component.options)
    } else {
      api.reload('3e56fcb6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3e56fcb6&", function () {
      api.rerender('3e56fcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/manager/components/detail.vue"
export default component.exports